import React from 'react'
import { Navbar, Footer, Databar, Newsbar } from '../../components';
import { Header, Info, Market, Forecast, Models } from '../Home'

export default function Home() {
  return (
    <div className="Home">
      <Navbar />
      <Header />
      <Databar />
      <Newsbar />
      <Info />
      <Market />
      <Models />
      <Forecast />
      <Footer />
    </div>
  )
}
